import _slicedToArray from "/opt/build/repo/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { minimumFontSize, verticalRhythm } from '../typography';
import { getShorthand } from '../utils/boxmodel';
export var button = {
  getSize: function getSize(sizes, iconPos) {
    // sizes is an array of four values. Map over the array, and add 'rem' to the value, if it isn't 0.
    var _getShorthand = getShorthand(sizes),
        _getShorthand2 = _slicedToArray(_getShorthand, 4),
        t = _getShorthand2[0],
        r = _getShorthand2[1],
        b = _getShorthand2[2],
        l = _getShorthand2[3];

    if (iconPos === 'left') {
      l = l - (l * 0.75).toFixed(2);
      r = r - (r * 0.25).toFixed(2);
    } else if (iconPos === 'right') {
      r = r - (r * 0.75).toFixed(2);
      l = l - (l * 0.4).toFixed(2);
    } else if (iconPos) {
      l = t;
      r = t;
      b = t;
    }

    return [t, r, b, l];
  },
  bg: "#000000",
  color: "#FFFFFF",
  sm: {
    padding: [(verticalRhythm * .25).toFixed(2), 1.5],
    margin: [(verticalRhythm * .25).toFixed(2), 0],
    fontSize: (minimumFontSize * 0.8).toFixed(2),
    lineHeight: verticalRhythm
  },
  md: {
    padding: [(verticalRhythm * .5).toFixed(2), 3],
    margin: [(verticalRhythm * .5).toFixed(2), 0],
    fontSize: minimumFontSize,
    lineHeight: verticalRhythm
  },
  lg: {
    padding: [(verticalRhythm * .75).toFixed(2), 4],
    margin: [(verticalRhythm * .25).toFixed(2), 0],
    fontSize: (minimumFontSize * 1.25).toFixed(2),
    lineHeight: verticalRhythm
  }
};